module.exports = __webpack_public_path__ + "ClientApp/content/VetResourceCenter/geriatric-clinic-tips.jpg";